import { CollapseHeight } from 'constants/collapse-height';

export const getCollapseHeight = hiddenThreshold => {
  let height = CollapseHeight.TEN_HEIGHT;
  if (hiddenThreshold === 3) {
    height = CollapseHeight.THREE_HEIGHT;
  } else if (hiddenThreshold === 5) {
    height = CollapseHeight.FIVE_HEIGHT;
  }

  return height;
};
